import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

interface SpinnerProps {
    isLoading: boolean;
    size?: number;
    margin?: string;
    color?: string;
}
const Spinner: React.FC<SpinnerProps> = ({ isLoading, size, margin, color }) => {
    return (
        <>
            <ClipLoader
                color={color ? color : 'black'}
                loading={isLoading}
                cssOverride={{
                    display: 'block',
                    margin: margin && margin,
                }}
                size={size && size}
            />
        </>
    );
};

export default Spinner;
